import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import cx from 'classnames'
import { animate } from 'gnos-utilities/animation'
import _ from 'lodash'

import NavigationItem from './components/Item'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class NavigationBar extends Component {
    static propTypes = {
        blocks: PropTypes.array,
        expanded: PropTypes.bool,
        intl: PropTypes.object,
        maxPosition: PropTypes.number,
        noAnimate: PropTypes.bool,
        position: PropTypes.number,
        reportNavigationSetPosition: PropTypes.func.isRequired,
        reportNavigationToggleExpanded: PropTypes.func.isRequired,
        scrollingDelta: PropTypes.number,
        scrollRefs: PropTypes.object,
        scrollTo: PropTypes.func.isRequired,
        visibleBlocks: PropTypes.object,
    }

    static defaultProps = {
        blocks: [],
        expanded: false,
        scrollRefs: {},
        scrollingDelta: 100,
        noAnimate: false,
    }

    componentDidMount() {
        const { position } = this.props

        this.setPosition(position)

        window.addEventListener('resize', this.handleResize)
    }

    componentDidUpdate(prevProps) {
        const { blocks } = this.props

        if (!_.isEqual(blocks, prevProps.blocks)) this.setPosition(0) // Reset navigation scroll and handle new scroll height
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    setPosition = (position) => {
        const { reportNavigationSetPosition, noAnimate } = this.props

        const maxPosition = (this._navButtons && this._navButtons.scrollHeight - this._navButtons.clientHeight) || 0
        const boundPosition = _.clamp(position, 0, maxPosition)

        if (this._navButtons) {
            if (!noAnimate) {
                animate(this._navButtons, 'scrollTop', position, 150)
                reportNavigationSetPosition(boundPosition, maxPosition)
            } else {
                this._navButtons.scrollTop = position
                reportNavigationSetPosition(boundPosition, maxPosition)
            }
        }
    }

    handleResize() {
        if (this._navButtons) this.setPosition(this._navButtons.scrollTop)
    }

    handleToggleExpanded = () => {
        const { reportNavigationToggleExpanded } = this.props

        reportNavigationToggleExpanded()
    }

    handleNavigationItemClick = (block) => {
        const { scrollTo, scrollRefs } = this.props

        scrollTo(scrollRefs[block])
    }

    handleMoveClick = (type) => {
        const { scrollingDelta } = this.props

        const delta = type === 'up' ? -scrollingDelta : scrollingDelta

        const newPosition = this._navButtons.scrollTop + delta

        this.setPosition(newPosition)

        return null
    }

    renderItems = () => {
        const { blocks, expanded, visibleBlocks } = this.props

        return blocks.map((block) => (
            <NavigationItem
                key={`report-navigation-bar-item-${block}`}
                block={block}
                expanded={expanded}
                visibleBlocks={visibleBlocks}
                handleBtnClick={this.handleNavigationItemClick}
            />
        ))
    }

    render() {
        const { expanded, position, maxPosition, intl } = this.props

        return (
            <div className={cx('report-workspace-navigation-bar', expanded && 'expanded')} style={{ top: '0' }}>
                <div className={'top-controls'}>
                    <button
                        className={'navigation-expand-btn'}
                        onClick={this.handleToggleExpanded}
                        title={
                            expanded
                                ? intl.formatMessage({ id: `${LOCALE_PREFIX}.hide` })
                                : intl.formatMessage({ id: `${LOCALE_PREFIX}.expand` })
                        }
                    />
                    <div className={'navigation-label'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.navigationTitle`} />
                    </div>
                    <button
                        className={'navigation-upwards-btn'}
                        onClick={() => this.handleMoveClick('up')}
                        disabled={position <= 0}
                        title={intl.formatMessage({ id: `${LOCALE_PREFIX}.up` })}
                    />
                </div>
                <div className={'navigation-items-wrap'} ref={(r) => (this._navButtons = r)}>
                    <div className={'navigation-items'}>{this.renderItems()}</div>
                </div>
                <div className={'bottom-controls'}>
                    <button
                        className={'navigation-downwards-btn'}
                        onClick={() => this.handleMoveClick('down')}
                        disabled={position >= maxPosition}
                        title={intl.formatMessage({ id: `${LOCALE_PREFIX}.down` })}
                    />
                </div>
            </div>
        )
    }
}
